import React from "react";
import {IonHeader, IonPage} from "@ionic/react";
import AppToolbar from "../../components/utils/AppToolbar";
import MainMapContainer from "../../components/map/containers/MainMapContainer";
import {WithTranslation, withTranslation} from "react-i18next";

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 16/03/2022
 * @last_update 16/03/2022
 **/
class MapPage extends React.Component<WithTranslation> {

    render() {

        return (

            <IonPage>
                <IonHeader>
                    <AppToolbar appTitle={this.props.t("pages.map.title")}/>
                </IonHeader>
                <MainMapContainer/>
            </IonPage>

        );

    };

}

export default withTranslation()(MapPage);
